<template>
  <div class="books">
    <h1>HOME Page done</h1>
  </div>
</template>

<script>

export default {
  components: {

  },
};
</script>
